import { call, fork, put, take } from 'redux-saga/effects';
import { loadUser, recordPayment, setLoadedUser } from './reducer';
import apiService from '../../api/apiServices/apiService';
import { toast } from 'react-toastify';

function* watchLoadUser() {
  while (true) {
    const { payload }: ReturnType<typeof loadUser> = yield take(loadUser.type);

    const { success, reject } = yield call([apiService, apiService.getUser], payload);

    if (success) {
      yield put(setLoadedUser(success.payload));
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

function* watchRecordPayment() {
  while (true) {
    const { payload }: ReturnType<typeof recordPayment> = yield take(recordPayment.type);

    const { success, reject } = yield call([apiService, apiService.recordReferralPayment], payload);

    if (success) {
      const result = success.payload as {
        commissionAmount?: number;
        referrerId?: number | null;
      };
      if (result.referrerId && result.commissionAmount) {
        toast.success(`Платёж записан. Комиссия: $${Number(result.commissionAmount).toFixed(2)}`);
      } else if (result.referrerId === null) {
        toast.warn('Платёж записан, но реферер не указан — комиссия 0');
      } else {
        toast.success('Платёж записан');
      }
      if (payload.userId) {
        yield put(loadUser(payload.userId));
      }
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

export default function* userSaga() {
  yield fork(watchLoadUser);
  yield fork(watchRecordPayment);
}
